"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { homepageFaqs } from "@/data/homepage-faqs"
import { FaqLeafChevron } from "./section-icons"
import { Reveal, Stagger } from "@/components/motion"

export function HomepageFaq() {
  return (
    <section className="bg-background px-7 py-12 md:py-16">
      <div className="max-w-2xl mx-auto">
        <Reveal>
          <h2 className="text-center font-bold tracking-[-0.02em] text-gray-900 mb-8 md:mb-10 text-[28px] md:text-4xl">
            Common questions
          </h2>
        </Reveal>

        <Stagger>
          <AccordionPrimitive.Root type="single" collapsible className="divide-y divide-gray-200">
            {homepageFaqs.map((faq) => (
              <Stagger.Item key={faq.question}>
                <AccordionPrimitive.Item value={faq.question}>
                  <AccordionPrimitive.Header className="flex">
                    <AccordionPrimitive.Trigger className="group flex flex-1 items-center justify-between gap-4 py-4 text-left text-[15px] sm:text-base font-semibold text-gray-900 hover:text-green-700 transition-colors">
                      <span>{faq.question}</span>
                      <FaqLeafChevron className="w-4 h-4 shrink-0 text-green-600 transition-transform duration-200 ease-out group-data-[state=open]:rotate-180" />
                    </AccordionPrimitive.Trigger>
                  </AccordionPrimitive.Header>
                  <AccordionPrimitive.Content className="overflow-hidden text-sm sm:text-[15px] text-gray-600 leading-relaxed data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                    <p className="pb-4">{faq.answer}</p>
                  </AccordionPrimitive.Content>
                </AccordionPrimitive.Item>
              </Stagger.Item>
            ))}
          </AccordionPrimitive.Root>
        </Stagger>
      </div>
    </section>
  )
}
